import {AgreementsStore} from "./agreements.store";
import {AgreementsService} from "../../../services/agreements/agreements.service";
import React from "react";
import {Agreement} from "../../../models/agreements/agreement";

export class AgreementsController {
    constructor(
        private readonly _agreementsStore: AgreementsStore,
        private readonly _agreementsService: AgreementsService
    ) {
        this.init();
    }

    private async init(): Promise<void> {
        this._agreementsStore.setLoading(true);
        this._agreementsStore.setAgreements(await this._agreementsService.getAgreements());
        this._agreementsStore.setLoading(false);
    }

    public async onAgreementCheck(checked: boolean, agreement: Agreement): Promise<void> {
        if (checked) {
            await this._agreementsService.approveAgreement(agreement.id);
            this._agreementsStore.editAgreement(agreement, {approval: true});
            return;
        }
        await this._agreementsService.disapproveAgreement(agreement.id);
        this._agreementsStore.editAgreement(agreement, {approval: false});
    }
}

export const AgreementsControllerContext = React.createContext<null | AgreementsController>(null) as React.Context<AgreementsController>;